import { PARTNERS } from "@/data/site";

export default function PartnersMarquee() {
  const items = [...PARTNERS, ...PARTNERS];
  return (
    <section data-testid="partners-marquee" className="py-14 bg-white border-y border-teh-navy/10 overflow-hidden">
      <div className="teh-container mb-8">
        <p className="text-center text-xs font-semibold uppercase tracking-[0.22em] text-teh-green">
          Trusted Network & Broker Partnerships
        </p>
      </div>
      <div className="relative">
        <div className="teh-marquee">
          {items.map((p, i) => (
            <div
              key={`${p}-${i}`}
              className="shrink-0 px-10 font-serif text-2xl md:text-3xl text-teh-navy/40"
            >
              {p}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
